module.exports = __webpack_public_path__ + "static/media/lincoln-logo.da77ed18.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/lincoln-logo.png
// module id = 7356
// module chunks = 4